(function() {
  'use strict';

  var SIZE_GUIDE_STORAGE_KEY = 'beoutRingSizeGuideSeenV1';
  var SIZE_GUIDE_TTL = 24 * 60 * 60 * 1000;
  var HOLDER_DISMISSED_STORAGE_KEY = 'beoutRingHolderOfferDismissedV1';
  var APP_CART_WAIT_MS = 9000;
  var APP_CART_POLL_MS = 300;
  var BUNDLE_OPTIONS_ATTR_PREFIX = '_beout_bundle_opts_';
  var BUNDLE_OPTIONS_WAIT_MS = 25000;
  var BUNDLE_OPTIONS_POLL_MS = 400;
  var BUNDLE_CARD_SELECTOR = '.gbbPbProductBundleWrapper .gbbPbProductCard, .gbbPbProductPageAppBlock .gbbPbProductCard, .gbbPbBundleBodyAndFooterWrapper .gbbPbProductCard';

  var state = {
    initialized: false,
    root: null,
    sizeModal: null,
    holderModal: null,
    activeOffer: null,
    replayingAppButton: null,
    replayingNativeSubmit: false,
    pendingNativeHolder: null,
    pendingAppHolder: null,
    bundleSelection: null,
    bundleWatcher: null
  };

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Storage may be unavailable in private browsing; the flow still works for this page.
    }
  }

  function hasRecentSizeGuideView() {
    var timestamp = Number(readStorage(SIZE_GUIDE_STORAGE_KEY) || 0);
    if (!timestamp || Date.now() - timestamp >= SIZE_GUIDE_TTL) {
      try {
        window.localStorage.removeItem(SIZE_GUIDE_STORAGE_KEY);
      } catch (error) {
        // Ignore storage errors.
      }
      return false;
    }
    return true;
  }

  function rememberSizeGuideView() {
    writeStorage(SIZE_GUIDE_STORAGE_KEY, String(Date.now()));
  }

  function holderOfferWasDismissed() {
    return readStorage(HOLDER_DISMISSED_STORAGE_KEY) === 'true';
  }

  function rememberHolderOfferDismissal() {
    writeStorage(HOLDER_DISMISSED_STORAGE_KEY, 'true');
  }

  function getCartDrawer() {
    return document.querySelector('mini-cart');
  }

  function cartDrawerIsAvailable() {
    if (document.body.classList.contains('template-cart')) return false;
    if (window.theme && window.theme.shopSettings && window.theme.shopSettings.cartDrawer === false) return false;
    return !!getCartDrawer();
  }

  function getCartUrl(path) {
    if (window.theme && window.theme.routes && window.theme.routes[path]) return window.theme.routes[path];
    if (path === 'cart_add_url') return '/cart/add';
    if (path === 'cart_update_url') return '/cart/update.js';
    if (path === 'cart_change_url') return '/cart/change.js';
    return '/cart.js';
  }

  function getCartState() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function(response) {
      if (!response.ok) throw new Error('Não foi possível consultar o carrinho.');
      return response.json();
    });
  }

  function cartSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return '';
    return cart.items.map(function(item) {
      return [item.key || item.variant_id || item.id, item.quantity].join(':');
    }).sort().join('|');
  }

  function openModal(modal, focusTarget) {
    if (!modal) return;
    if (typeof modal.show === 'function') {
      modal.show(focusTarget || document.body);
    } else if (typeof modal.showModal === 'function' && !modal.open) {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    if (focusTarget && typeof focusTarget.focus === 'function') {
      window.setTimeout(function() { focusTarget.focus(); }, 0);
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    if (typeof modal.hide === 'function') {
      modal.hide();
    } else if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
  }

  function showSizeGuide() {
    if (!state.sizeModal || hasRecentSizeGuideView()) return;
    rememberSizeGuideView();
    openModal(state.sizeModal, state.sizeModal.querySelector('[data-beout-size-confirm]'));
  }

  function isInsideBundleApp(node) {
    return !!(node && node.closest && node.closest('.gbbPbProductBundleWrapper, .gbbPbProductPageAppBlock'));
  }

  function handleBundleSizeClick(event) {
    if (!state.root || state.activeOffer) return;
    var target = event.target && event.target.closest
      ? event.target.closest('.gbbPbProductBundleWrapper .labelPickerItem, .gbbPbProductPageAppBlock .labelPickerItem')
      : null;
    if (!target || !isInsideBundleApp(target) || hasRecentSizeGuideView()) return;

    window.setTimeout(function() {
      showSizeGuide();
    }, 40);
  }

  function nativeSubmitIsReady(form, submitter) {
    var medidorButton = form.querySelector('[data-medidor-submit]');
    if (!medidorButton) return true;
    if (submitter && submitter !== medidorButton) return false;
    return medidorButton.classList.contains('medidor-flow__submit--ready');
  }

  function isNativePurchaseForm(form, submitter) {
    if (!form || !form.matches('form[action$="/cart/add"], form[action="/cart/add"]')) return false;
    if (!submitter || submitter.type !== 'submit' || submitter.name !== 'add') return false;
    if (submitter.matches('[data-sdk-atc-btn], .gbbPbHideThemeComponent')) return false;
    if (isInsideBundleApp(form)) return false;
    if (!nativeSubmitIsReady(form, submitter)) return false;
    return true;
  }

  function canShowHolderOffer() {
    if (!state.root || !state.root.getAttribute('data-beout-ring-holder-variant-id')) return false;
    if (holderOfferWasDismissed()) return false;
    if (state.activeOffer || state.pendingNativeHolder || state.pendingAppHolder) return false;
    return cartDrawerIsAvailable();
  }

  function getFallbackSubmitter(form) {
    return form.querySelector('button[type="submit"][name="add"]');
  }

  function showHolderOffer(offer) {
    if (!state.holderModal || !canShowHolderOffer()) return false;
    var quantityInput = state.holderModal.querySelector('[data-beout-holder-quantity-input]');
    if (quantityInput) quantityInput.value = '1';
    state.activeOffer = offer;
    openModal(state.holderModal, state.holderModal.querySelector('[data-beout-holder-add]'));
    return true;
  }

  function getHolderQuantity() {
    var input = state.holderModal && state.holderModal.querySelector('[data-beout-holder-quantity-input]');
    var quantity = input ? Number(input.value) : 1;
    if (!Number.isFinite(quantity)) quantity = 1;
    quantity = Math.round(quantity);
    quantity = Math.max(1, Math.min(10, quantity));
    if (input) input.value = String(quantity);
    return quantity;
  }

  function replayNativeSubmission(offer) {
    if (!offer || !offer.form) return;
    var form = offer.form;
    var submitter = offer.submitter || getFallbackSubmitter(form);
    state.replayingNativeSubmit = true;

    if (typeof form.requestSubmit === 'function') {
      if (submitter && submitter.form === form) form.requestSubmit(submitter);
      else form.requestSubmit();
    } else if (submitter) {
      submitter.click();
    }

    window.setTimeout(function() {
      state.replayingNativeSubmit = false;
    }, 1200);
  }

  function replayAppButton(offer) {
    if (!offer) return;
    var button = offer.button && offer.button.isConnected
      ? offer.button
      : document.querySelector('.gbbPbProductBundleWrapper .gbbPbAddToCartBtn, .gbbPbProductPageAppBlock .gbbPbAddToCartBtn');
    if (!button) return;

    var attemptsRemaining = 12;
    var replay = function() {
      if (!button.isConnected) return;
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
        attemptsRemaining -= 1;
        if (attemptsRemaining > 0) window.setTimeout(replay, 100);
        return;
      }

      state.replayingAppButton = button;
      button.click();
      window.setTimeout(function() {
        if (state.replayingAppButton === button) state.replayingAppButton = null;
      }, 1200);
    };

    window.setTimeout(replay, 40);
  }

  function finishHolderOffer(action) {
    var offer = state.activeOffer;
    if (!offer) return;
    if (action === 'add') offer.holderQuantity = getHolderQuantity();
    state.activeOffer = null;
    closeModal(state.holderModal);

    if (action === 'dismiss') rememberHolderOfferDismissal();

    if (offer.type === 'native') {
      if (action === 'add') {
        startNativeAddWithHolder(offer);
      } else {
        replayNativeSubmission(offer);
      }
    } else if (offer.type === 'app') {
      if (action === 'add') {
        startAppAddWithHolder(offer);
      } else {
        replayAppButton(offer);
      }
    }
  }

  function createCartAddConfig(formData) {
    var config = typeof window.fetchConfig === 'function'
      ? window.fetchConfig('javascript')
      : { method: 'POST', headers: {} };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;
    return config;
  }

  function addHolderVariant(quantity) {
    var variantId = state.root && state.root.getAttribute('data-beout-ring-holder-variant-id');
    if (!variantId) return Promise.reject(new Error('Produto do porta-alianças não configurado.'));

    quantity = Math.max(1, Math.min(10, Math.round(Number(quantity) || 1)));
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', String(quantity));
    formData.append('properties[_beout_upsell]', 'Porta-Alianças Beout');

    var miniCart = getCartDrawer();
    if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
      formData.append('sections', miniCart.getSectionsToRender().map(function(section) { return section.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
    }

    return fetch(getCartUrl('cart_add_url'), createCartAddConfig(formData))
      .then(function(response) {
        return response.json().then(function(parsed) {
          if (!response.ok || parsed.status) {
            throw new Error(parsed.description || 'Não foi possível adicionar o porta-alianças.');
          }
          return parsed;
        });
      })
      .then(function(parsed) {
        if (miniCart && typeof miniCart.renderContents === 'function' && parsed.sections) {
          miniCart.renderContents(parsed);
          window.setTimeout(function() {
            var recommendations = document.querySelector('#mini-cart cart-recommendations');
            if (recommendations && typeof recommendations.loadRecommendations === 'function') {
              recommendations.loadRecommendations();
            }
          }, 0);
        } else {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));
        }
        return parsed;
      });
  }

  function startNativeHolderWatcher(beforePromise) {
    var startedAt = Date.now();
    var check = function() {
      var pending = state.pendingNativeHolder;
      if (!pending || pending.adding) return;

      getCartState().then(function(cart) {
        if (!state.pendingNativeHolder || state.pendingNativeHolder.adding) return;
        var changed = !pending.beforeSignature || cartSignature(cart) !== pending.beforeSignature;
        if (changed) {
          addPendingHolderOnce('native');
          return;
        }
        if (Date.now() - startedAt < APP_CART_WAIT_MS) {
          window.setTimeout(check, APP_CART_POLL_MS);
        }
      }).catch(function() {
        if (Date.now() - startedAt < APP_CART_WAIT_MS) window.setTimeout(check, APP_CART_POLL_MS);
      });
    };

    Promise.resolve(beforePromise).finally(function() {
      window.setTimeout(check, 100);
    });
  }

  function addPendingHolderOnce(source) {
    var pending = source === 'app' ? state.pendingAppHolder : state.pendingNativeHolder;
    if (!pending || pending.adding) return;
    pending.adding = true;

    addHolderVariant(pending.quantity).catch(function(error) {
      console.error('[Beout] Porta-alianças:', error);
    }).finally(function() {
      if (source === 'app') state.pendingAppHolder = null;
      else state.pendingNativeHolder = null;
    });
  }

  function startNativeAddWithHolder(offer) {
    var beforePromise = offer.beforeCartPromise || getCartState();
    state.pendingNativeHolder = {
      beforeSignature: '',
      adding: false,
      quantity: offer.holderQuantity || 1
    };
    Promise.resolve(beforePromise).then(function(cart) {
      if (state.pendingNativeHolder) state.pendingNativeHolder.beforeSignature = cartSignature(cart);
    }).catch(function() {
      // The pub/sub success signal below remains the primary path if the snapshot fails.
    });

    replayNativeSubmission(offer);
    startNativeHolderWatcher(beforePromise);
  }

  function startAppAddWithHolder(offer) {
    var beforePromise = offer.beforeCartPromise || getCartState();
    state.pendingAppHolder = {
      beforeSignature: '',
      adding: false,
      quantity: offer.holderQuantity || 1
    };

    Promise.resolve(beforePromise).then(function(cart) {
      if (state.pendingAppHolder) state.pendingAppHolder.beforeSignature = cartSignature(cart);
    }).catch(function() {
      // If the snapshot fails, the app/cart events can still complete the flow.
    });

    replayAppButton(offer);
    startAppHolderWatcher(beforePromise);
  }

  function startAppHolderWatcher(beforePromise) {
    var startedAt = Date.now();
    var check = function() {
      var pending = state.pendingAppHolder;
      if (!pending || pending.adding) return;

      getCartState().then(function(cart) {
        if (!state.pendingAppHolder || state.pendingAppHolder.adding) return;
        var changed = !pending.beforeSignature || cartSignature(cart) !== pending.beforeSignature;
        if (changed) {
          addPendingHolderOnce('app');
          return;
        }
        if (Date.now() - startedAt < APP_CART_WAIT_MS) {
          window.setTimeout(check, APP_CART_POLL_MS);
        }
      }).catch(function() {
        if (Date.now() - startedAt < APP_CART_WAIT_MS) window.setTimeout(check, APP_CART_POLL_MS);
      });
    };

    Promise.resolve(beforePromise).finally(function() {
      window.setTimeout(check, 150);
    });
  }

  /* ---------------------------------------------------------------------------
   * Identificação das variantes escolhidas no app de kits (Easy Bundle).
   * O app junta os produtos do kit em uma única linha do carrinho (Cart Transform),
   * e essa linha perde o tamanho escolhido em cada anel. Guardamos a seleção em um
   * atributo oculto do carrinho, indexado pelo id da oferta (`_originalOfferId`),
   * para o tema exibir "Tamanhos: 20 e 24" na descrição do item.
   * ------------------------------------------------------------------------ */

  function cleanText(node) {
    if (!node || !node.textContent) return '';
    return node.textContent.replace(/\s+/g, ' ').replace(/[:*\s]+$/, '').trim();
  }

  function pluralizeOptionName(name) {
    if (!name) return '';
    if (/s$/i.test(name)) return name;
    if (/ão$/i.test(name)) return name.slice(0, -2) + 'ões';
    if (/[rz]$/i.test(name)) return name + 'es';
    if (/m$/i.test(name)) return name.slice(0, -1) + 'ns';
    if (/l$/i.test(name)) return name.slice(0, -1) + 'is';
    return name + 's';
  }

  function sanitizeAttributeChunk(value) {
    return String(value || '').replace(/\|/g, '/').replace(/\s+/g, ' ').trim().slice(0, 120);
  }

  function collectBundleCardSelections() {
    var cards = document.querySelectorAll(BUNDLE_CARD_SELECTOR);
    var seen = [];
    var selections = [];

    for (var index = 0; index < cards.length; index += 1) {
      var card = cards[index];
      if (seen.indexOf(card) !== -1) continue;
      seen.push(card);

      var groups = card.querySelectorAll('.gbbPbOption');
      var options = [];

      for (var groupIndex = 0; groupIndex < groups.length; groupIndex += 1) {
        var group = groups[groupIndex];
        var name = cleanText(group.querySelector('.gbbPbOptionHeading, legend'));
        var value = '';

        var checked = group.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
        if (checked && checked.value) value = checked.value;

        if (!value) {
          var select = group.querySelector('select');
          if (select && select.value) value = select.value;
        }

        if (!value) {
          var active = group.querySelector('.labelPickerItem.selected, .labelPickerItem.active, .labelPickerItem.is-selected, .labelPickerItem[aria-checked="true"]');
          if (active) value = active.getAttribute('title') || cleanText(active);
        }

        value = sanitizeAttributeChunk(value);
        if (value) options.push({ name: name || 'Opção', value: value });
      }

      if (options.length) {
        selections.push({ title: cleanText(card.querySelector('.gbbPbProductCardTitle')), options: options });
      }
    }

    return selections;
  }

  function joinValues(values) {
    if (values.length < 2) return values.join('');
    return values.slice(0, -1).join(', ') + ' e ' + values[values.length - 1];
  }

  function formatBundleSelections(selections) {
    if (!selections || !selections.length) return null;

    var names = [];
    var values = [];
    var singleOptionPerProduct = true;

    selections.forEach(function(selection) {
      if (selection.options.length !== 1) singleOptionPerProduct = false;
      selection.options.forEach(function(option) {
        if (names.indexOf(option.name) === -1) names.push(option.name);
        values.push(option.value);
      });
    });

    if (!values.length) return null;

    if (singleOptionPerProduct && names.length === 1) {
      var label = values.length > 1 ? pluralizeOptionName(names[0]) : names[0];
      return { label: sanitizeAttributeChunk(label), value: sanitizeAttributeChunk(joinValues(values)) };
    }

    var parts = selections.map(function(selection) {
      var detail = selection.options.map(function(option) {
        return option.name + ': ' + option.value;
      }).join(', ');
      return selection.title ? selection.title + ' (' + detail + ')' : detail;
    });

    return { label: 'Opções', value: sanitizeAttributeChunk(parts.join(' • ')) };
  }

  function bundleOfferIdFromItem(item) {
    var properties = item && item.properties;
    if (!properties) return '';
    var offerId = properties._originalOfferId || properties._EasyBundleId || '';
    return String(offerId || '').trim();
  }

  function bundleOfferCounts(cart) {
    var counts = {};
    if (!cart || !Array.isArray(cart.items)) return counts;
    cart.items.forEach(function(item) {
      var offerId = bundleOfferIdFromItem(item);
      if (!offerId) return;
      counts[offerId] = (counts[offerId] || 0) + (Number(item.quantity) || 1);
    });
    return counts;
  }

  function renderCartSectionsQuietly(parsed) {
    var miniCart = getCartDrawer();
    if (!miniCart || !parsed || !parsed.sections || typeof miniCart.getSectionsToRender !== 'function') return;

    miniCart.getSectionsToRender().forEach(function(section) {
      var container = document.getElementById(section.id);
      var markup = parsed.sections[section.id];
      if (!container || !markup) return;
      try {
        var parsedMarkup = new DOMParser().parseFromString(markup, 'text/html');
        var replacement = parsedMarkup.querySelector(section.selector);
        if (replacement) container.innerHTML = replacement.innerHTML;
      } catch (error) {
        // Se o parsing falhar, o carrinho continua válido; apenas não atualizamos o trecho.
      }
    });

    document.dispatchEvent(new CustomEvent('cartdrawer:updated'));
  }

  function saveBundleOptionsAttribute(cart, offerId, selection) {
    if (!offerId || !selection || !selection.value) return;

    var attributes = {};
    var activeOffers = bundleOfferCounts(cart);
    var existingAttributes = (cart && cart.attributes) || {};

    Object.keys(existingAttributes).forEach(function(key) {
      if (key.indexOf(BUNDLE_OPTIONS_ATTR_PREFIX) !== 0) return;
      var storedOffer = key.slice(BUNDLE_OPTIONS_ATTR_PREFIX.length);
      if (!activeOffers[storedOffer]) attributes[key] = '';
    });

    attributes[BUNDLE_OPTIONS_ATTR_PREFIX + offerId] = selection.label + '|' + selection.value;

    var body = { attributes: attributes };
    var miniCart = getCartDrawer();
    if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
      body.sections = miniCart.getSectionsToRender().map(function(section) { return section.id; }).join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(getCartUrl('cart_update_url'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function(response) {
      return response.ok ? response.json() : null;
    }).then(function(parsed) {
      if (parsed) renderCartSectionsQuietly(parsed);
    }).catch(function() {
      // O rótulo é apenas informativo: falhas aqui não podem interromper a compra.
    });
  }

  function pollBundleOptionsWatcher(watcher) {
    if (!watcher || watcher.done || !watcher.before || state.bundleWatcher !== watcher) return;

    if (Date.now() - watcher.startedAt > BUNDLE_OPTIONS_WAIT_MS) {
      watcher.done = true;
      return;
    }

    getCartState().then(function(cart) {
      if (watcher.done || state.bundleWatcher !== watcher) return;

      var current = bundleOfferCounts(cart);
      var before = watcher.before;
      var target = '';

      Object.keys(current).forEach(function(offerId) {
        if (target || before[offerId]) return;
        target = offerId;
      });

      if (!target) {
        window.setTimeout(function() { pollBundleOptionsWatcher(watcher); }, BUNDLE_OPTIONS_POLL_MS);
        return;
      }

      watcher.done = true;
      saveBundleOptionsAttribute(cart, target, watcher.selection);
    }, function() {
      window.setTimeout(function() { pollBundleOptionsWatcher(watcher); }, BUNDLE_OPTIONS_POLL_MS);
    });
  }

  function trackBundleSelectionForAdd() {
    var selection = formatBundleSelections(collectBundleCardSelections());
    if (!selection) return;

    state.bundleSelection = selection;

    var watcher = { startedAt: Date.now(), before: null, done: false, selection: selection };
    state.bundleWatcher = watcher;

    getCartState().then(function(cart) {
      watcher.before = bundleOfferCounts(cart);
    }, function() {
      // Sem a foto anterior do carrinho não há como saber qual linha é a nova: desistimos do rótulo.
      watcher.done = true;
    }).then(function() {
      if (watcher.done) return;
      window.setTimeout(function() { pollBundleOptionsWatcher(watcher); }, BUNDLE_OPTIONS_POLL_MS);
    });
  }

  function handleNativeSubmit(event) {
    if (!state.root || state.replayingNativeSubmit || !canShowHolderOffer()) return;
    var form = event.target;
    var submitter = event.submitter || getFallbackSubmitter(form);
    if (!isNativePurchaseForm(form, submitter)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    showHolderOffer({
      type: 'native',
      form: form,
      submitter: submitter,
      beforeCartPromise: getCartState()
    });
  }

  function handleAppClick(event) {
    if (!state.root) return;
    var button = event.target && event.target.closest
      ? event.target.closest('.gbbPbProductBundleWrapper .gbbPbAddToCartBtn, .gbbPbProductPageAppBlock .gbbPbAddToCartBtn')
      : null;
    if (!button || !isInsideBundleApp(button)) return;

    trackBundleSelectionForAdd();

    if (state.replayingAppButton === button) {
      state.replayingAppButton = null;
      return;
    }
    if (!canShowHolderOffer() || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    showHolderOffer({
      type: 'app',
      button: button,
      beforeCartPromise: getCartState()
    });
  }

  function handleSuccessfulNativeCartUpdate(event) {
    if (!state.pendingNativeHolder || state.pendingNativeHolder.adding) return;
    if (event && event.source && event.source !== 'product-form') return;
    window.setTimeout(function() {
      addPendingHolderOnce('native');
    }, 100);
  }

  function init() {
    if (state.initialized) return;
    state.root = document.querySelector('[data-beout-ring-prompts]');
    if (!state.root) return;

    state.initialized = true;
    state.sizeModal = state.root.querySelector('[data-beout-size-modal]');
    state.holderModal = state.root.querySelector('[data-beout-holder-modal]');

    document.addEventListener('click', handleBundleSizeClick, true);
    document.addEventListener('click', handleAppClick, true);
    document.addEventListener('submit', handleNativeSubmit, true);

    state.root.querySelector('[data-beout-size-close]').addEventListener('click', function() {
      closeModal(state.sizeModal);
    });
    state.root.querySelector('[data-beout-size-confirm]').addEventListener('click', function() {
      closeModal(state.sizeModal);
    });
    state.root.querySelector('[data-beout-holder-close]').addEventListener('click', function() {
      finishHolderOffer('close');
    });
    state.root.querySelector('[data-beout-holder-no]').addEventListener('click', function() {
      finishHolderOffer('dismiss');
    });
    state.root.querySelector('[data-beout-holder-add]').addEventListener('click', function() {
      var button = this;
      button.disabled = true;
      button.classList.add('loading');
      finishHolderOffer('add');
      window.setTimeout(function() {
        button.disabled = false;
        button.classList.remove('loading');
      }, 1200);
    });

    [state.sizeModal, state.holderModal].forEach(function(modal) {
      if (!modal) return;
      modal.addEventListener('click', function(event) {
        if (event.target === modal) {
          if (modal === state.holderModal) finishHolderOffer('close');
          else closeModal(modal);
        }
      });
      modal.addEventListener('cancel', function(event) {
        event.preventDefault();
        if (modal === state.holderModal) finishHolderOffer('close');
        else closeModal(modal);
      });
    });

    if (typeof window.subscribe === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, handleSuccessfulNativeCartUpdate);
    } else if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, handleSuccessfulNativeCartUpdate);
    }

    document.addEventListener('ajaxProduct:added', function() {
      if (state.pendingAppHolder) {
        window.setTimeout(function() { addPendingHolderOnce('app'); }, 100);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();